/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Tabs,
  Select,
  DatePicker,
  notification,
} from "antd";
import iconplay from "../assets/img/video.png";
import iconfinalizado from "../assets/img/finalizado.png";
import comparte from "../assets/img/comparte.png";
import fb from "../assets/img/fb.png";
import lnk from "../assets/img/lnk.png";
import tw from "../assets/img/tw.png";
import { api } from "../settings";
import moment from "moment";
import axios from "axios";
import ReactGA from "react-ga";

const { TabPane } = Tabs;

const { TextArea } = Input;

const { Option } = Select;

function VideoSection() {
  const [form] = Form.useForm();
  const [videoId, setVideoId] = useState("654915464");
  const [showForm, setShowForm] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  let localTemasVideos = localStorage.getItem("temas_video")
    ? JSON.parse(localStorage.getItem("temas_video"))
    : [];
  const [temasVideos, setTemasVideos] = useState(localTemasVideos);
  const [formIsAvailable, setFormIsAvailable] = useState(false);
  const [currentTabSelected, setCurrentTabSelected] = useState(null);
  const [currentVideoSelected, setCurrentVideoSelected] = useState(null);

  useEffect(() => {
    window.scrollTo({top: 0})
    axios
      .get(`${process.env.PUBLIC_URL}/temasVideos.json`)
      .then((res) => res.data)
      .then((res) => {
        res.forEach((temas, indext) => {
          temas.videos.forEach((video) => {
            var videoPreviousVal = null;
            if (temasVideos[indext]) {
              videoPreviousVal = temasVideos[indext].videos.find(
                ({ videoId }) => videoId === video.videoId
              );
            }
            if (videoPreviousVal && videoPreviousVal.viewed !== undefined) {
              video.viewed = videoPreviousVal.viewed;
            }
          });
        });
        if (res[0] && res[0].videos[0]) {
          res[0].videos[0].viewed = true;
          let firstVideoId = res[0].videos[0].videoId;
          ReactGA.event({
            category: "Video",
            action: "Play",
            value: parseInt(firstVideoId),
          });
          trackVideo(firstVideoId);
          setCurrentVideoSelected(firstVideoId);
        }
        setTemasVideos(res);
      })
      .catch((error) => {});
    
    getFormConfig();
  }, []);

  const getFormConfig = () => {
    axios
      .get(`${process.env.PUBLIC_URL}/formConfig.json`)
      .then((res) => res.data)
      .then((res) => {
        if (res.formIsAvailable) {
          setFormIsAvailable(res.formIsAvailable);
        }
      })
      .catch((error) => {});
  };

  const trackVideo = (id) => {
    let apiParams = {
      video_id: id,
      email: localStorage.getItem("email"),
    };
    if (currentVideoSelected !== id) {
      api
        .get("tracker/register", { params: apiParams })
        .then((res) => res.data)
        .then((res) => {
          if (res.success) {
            setCurrentVideoSelected(id);
          }
        })
        .catch((error) => {});
    }
  };

  const playVideo = (id) => {
    ReactGA.event({
      category: "Video",
      action: "Play",
      value: parseInt(id),
    });
    setVideoId(id);
    let currentTemasAr = [...temasVideos];
    currentTemasAr.forEach((temas) => {
      temas.videos.forEach((video) => {
        if (video.videoId === id) {
          video.viewed = true;
        }
      });
    });
    localStorage.setItem("temas_video", JSON.stringify(currentTemasAr));
    setTemasVideos(currentTemasAr);

    trackVideo(id);
  }

  function callback(e, id) {
    e.preventDefault();
    playVideo(id);
  }

  function callbackTabs(key) {
    if (currentTabSelected !== key) {
      setCurrentTabSelected(key);
      let firstVideoId = temasVideos[key-1].videos[0].videoId
      playVideo(firstVideoId);
    }
  }

  function showFormClick() {
    setShowForm(!showForm);
  }

  const onFinish = (values) => {
    setLoadingSubmit(true);
    let apiParams = values;
    /*if (apiParams.fecha_nacimiento) {
      apiParams.fecha_nacimiento = moment(values.fecha_nacimiento).format(
        "YYYY-MM-DD"
      );
    }
    apiParams.email = localStorage.getItem("email");*/

    api
      .post("registroTaller/register", apiParams)
      .then((res) => res.data)
      .then((res) => {
        if (res.success) {
          form.resetFields();
          setShowForm(false);
          notification["success"]({
            message: "Muchas gracias por postular al Taller 24E que se llevará a cabo este 18 de Diciembre. Una vez revisemos tu postulación te haremos conocer el resultado por correo electrónico",
            duration: 15,
            placement: 'bottomRight',
          });
          ReactGA.event({
            category: "Formulario Taller 24E",
            action: "Registro",
          });
        }
        setLoadingSubmit(false);
      })
      .catch((error) => {
        setLoadingSubmit(false);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="content-padding">
        <div className="div-section-video">
          <h5 className="h5-title">
            Cómo AUMENTAR TUS VENTAS durante las Fiestas de Fin de Año y la
            próxima gestión
          </h5>
        </div>
      </div>

      <div className="content-padding section-video-desktop">
        <div className="video-section">
          <iframe
            title="Taller 24E"
            src={`https://player.vimeo.com/video/${videoId}?autoplay=1&loop=0&autopause=0`}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          ></iframe>
        </div>
        <div className="section-tabs-desktop">
          <div className="background-introduction">
            <div className="content-padding">
              <p className="text-introduction">
                Te presentamos a 3 Especialistas que te ayudarán en tu plan de
                ventas.
              </p>
            </div>
          </div>

          <Tabs
            defaultActiveKey="1"
            onChange={callbackTabs}
            className="tabs-videos"
          >
            {temasVideos.map((tema) => (
              <TabPane tab={tema.nombreExpositor} key={tema.key}>
                {tema.videos.map((video) => {
                  return (
                    <div className="data-videos" key={video.key}>
                      <div
                        className={`item-video ${
                          videoId === video.videoId ? "item-selected" : ""
                        }`}
                      >
                        <div className="iconplay-item-video">
                          <a
                            href="/#"
                            onClick={(e) => callback(e, video.videoId)}
                          >
                            <img src={iconplay} />
                          </a>
                        </div>
                        <div className="text-item-video">
                          <a
                            href="/#"
                            onClick={(e) => callback(e, video.videoId)}
                          >
                            {video.videoTitle}
                          </a>
                        </div>
                        {video.viewed ? (
                          <div className="iconcheck-item-video">
                            <img src={iconfinalizado} />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}
              </TabPane>
            ))}
          </Tabs>

          <div className="section-share">
            <div className="data-section-share">
              <div className="icon-share">
                <img src={comparte} />
              </div>
              <p className="texto-share">COMPARTIR</p>
              <div className="icons-socialmedia">
                <div className="icon-fb">
                  <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.taller24e.org/cursos/" target="_blank" rel="noreferrer">
                    <img src={fb} />
                  </a>
                </div>
                <div className="icon-lnk">
                  <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://www.taller24e.org/cursos/" target="_blank" rel="noreferrer">
                    <img src={lnk} />
                  </a>
                </div>
                <div className="icon-tw">
                  <a href="https://twitter.com/intent/tweet?url=https://www.taller24e.org/cursos/&text=" target="_blank" rel="noreferrer">
                    <img src={tw} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ height: 82 }}></div>
      </div>

      {formIsAvailable ? (
        <div className={`fixed-section ${showForm ? "fixed-top" : ""}`}>
          {showForm ? (
            <>
              <div className="background-formulario-registrate section-colors-black">
                <div className="content-padding">
                  <Button
                    className="button-close"
                    onClick={() => showFormClick()}
                  >
                    X
                  </Button>
                  <h4 className="title-modal">
                    REGÍSTRATE AL TALLER{" "}
                    <span className="span-title-modal">24</span>E
                  </h4>
                  <p style={{ textAlign: "center", marginBottom: 20 }}>
                    El Taller para Emprendedores 24E esta dirigido a personas con un negocio en marcha.
                    El Taller será llevado a cabo este <strong>Sábado 18 de Diciembre de manera virtual</strong> y tendrá una duración de 3 horas.
                  </p>
                  <p style={{ textAlign: "center", marginBottom: 20 }}>
                    El taller brindará herramientas para
                    mejorar sus procesos de venta.
                    <br/>
                    Los participantes del taller contarán con acceso a un ToolKit 24E que
                    les permitirá implementar
                    herramientas digitales y tradiciones, así como también las estrategias aprendidas durante
                    el Taller 24E.
                  </p>
                  <p style={{ textAlign: "center", marginBottom: 20 }}>
                    <strong>El registro será cerrado el 15 de Diciembre.</strong>
                  </p>
                  <Form
                    form={form}
                    name="basic"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    className="formulario-registrate"
                  >
                    <Form.Item
                      name="name"
                      className="form-item"
                      rules={[
                        { required: true, message: 'Por favor ingresa tu nombre completo' },
                      ]}
                    >
                      <Input placeholder="Nombre y Apellidos*" />
                    </Form.Item>
                    <Form.Item
                      name="email"
                      className="form-item"
                      rules={[
                        { required: true, message: 'Por favor ingresa tu correo' },
                        { type: "email", message: "No es un correo válido" },
                      ]}
                    >
                      <Input placeholder="Correo Electrónico*" type="email" />
                    </Form.Item>
                    <Form.Item
                      name="phonenumber"
                      className="form-item"
                      rules={[
                        { required: true, message: 'Por favor ingresa tu teléfono' },
                        {
                          pattern: new RegExp(/^[6,7]\d{7}$/i),
                          message: "No es un número de celular válido",
                        },
                      ]}
                    >
                      <Input placeholder="Teléfono*" type="number" />
                    </Form.Item>
                    
                    <Form.Item name="fecha_nacimiento" className="form-item">
                      <Input placeholder="Fecha de nacimiento (dd-mm-yyyy)" />
                    </Form.Item>

                    <Form.Item
                      name="carnet"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: "Por favor ingresa tu Carnet de Identidad",
                        },
                      ]}
                    >
                      <Input placeholder="Número de Carnet de Identidad (CI)*" />
                    </Form.Item>

                    <Form.Item
                      name="ciudad"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: "Por favor completa este campo",
                        },
                      ]}
                    >
                      <Input placeholder="Ciudad*" />
                    </Form.Item>

                    <Form.Item
                      name="empresa_idea_negocio"
                      label="¿Cuentas con un negocio/emprendimiento?"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona una opción",
                        },
                      ]}
                    >
                      <Select>
                        <Option value="si">Si</Option>
                        <Option value="no">No</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.empresa_idea_negocio !==
                        currentValues.empresa_idea_negocio
                      }
                    >
                      {({ getFieldValue }) =>
                        getFieldValue("empresa_idea_negocio") === "no" ? (
                          <>
                            <Form.Item
                              name="idea_negocio_descripcion"
                              className="form-item"
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor completa este campo",
                                },
                              ]}
                            >
                              <TextArea
                                maxLength={100}
                                style={{ height: 120 }}
                                placeholder="¿Cuál es tu idea de negocio?*"
                              />
                            </Form.Item>
                            <Form.Item
                              name="idea_negocio_participacion_foro"
                              className="form-item"
                            >
                              <TextArea
                                maxLength={100}
                                style={{ height: 120 }}
                                placeholder="¿Por qué deseas ser parte del Foro para Emprendedores 24E?"
                              />
                            </Form.Item>
                          </>
                        ) : getFieldValue("empresa_idea_negocio") === "si" ? (
                          <>
                            <Form.Item
                              name="negocio_nombre"
                              className="form-item"
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor completa este campo",
                                },
                              ]}
                            >
                              <Input placeholder="Nombre del Negocio/Emprendimiento*" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_cargo"
                              className="form-item"
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor completa este campo",
                                },
                              ]}
                            >
                              <Select placeholder="Cargo que tiene en el emprendimiento/negocio*">
                                <option value="gerente-general">
                                  Gerente General
                                </option>
                                <option value="responsable-de-area">
                                  Responsable de Área
                                </option>
                                <option value="otro">
                                  Otro
                                </option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="negocio_nro_participantes"
                              className="form-item"
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor completa este campo",
                                },
                              ]}
                            >
                              <Select placeholder="¿Cuántas personas trabajan en tu negocio?*">
                                <option value="de-1-a-5">De 1 a 5</option>
                                <option value="de-6-a-10">De 6 a 10</option>
                                <option value="mas-de-10">Más de 10</option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="negocio_website"
                              className="form-item"
                            >
                              <Input placeholder="Página web del emprendimiento/negocio" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_facebook"
                              className="form-item"
                            >
                              <Input placeholder="Enlace al perfil de Facebook" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_linkedin"
                              className="form-item"
                            >
                              <Input placeholder="Enlace al perfil de LinkedIn" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_twitter"
                              className="form-item"
                            >
                              <Input placeholder="Enlace al perfil de Twitter" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_instagram"
                              className="form-item"
                            >
                              <Input placeholder="Enlace al perfil de Instagram" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_tik_tok"
                              className="form-item"
                            >
                              <Input placeholder="Enlace de al perfil de Tik Tok" />
                            </Form.Item>

                            <Form.Item
                              name="negocio_rubro"
                              className="form-item"
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor completa este campo",
                                },
                              ]}
                            >
                              <Select placeholder="Rubro/Industria del negocio*">
                                <option value="servicios">Servicios </option>
                                <option value="comercio">Comercio</option>
                                <option value="tecnologia">Tecnología</option>
                                <option value="alimentos">Alimentos</option>
                                <option value="transporte">Transporte</option>
                                <option value="telecomunicaciones">
                                  Telecomunicaciones
                                </option>
                                <option value="salud">Salud</option>
                                <option value="equipamiento-y-construccion">
                                  Equipamiento y construcción
                                </option>
                                <option value="textil">Textil</option>
                                <option value="turismo">Turismo </option>
                                <option value="agropecuario-y-ganaderia">
                                  Agropecuario y Ganadería
                                </option>
                                <option value="otro">
                                  Otro
                                </option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="negocio_participacion_taller"
                              className="form-item"
                            >
                              <TextArea
                                maxLength={100}
                                style={{ height: 120 }}
                                placeholder="¿Por qué deseas ser parte del Taller para Emprendedores 24E?"
                              />
                            </Form.Item>
                          </>
                        ) : (
                          ""
                        )
                      }
                    </Form.Item>
                    <Form.Item
                      className="centerButton"
                      style={{ marginBottom: 0 }}
                    >
                      <Button
                        className="button-main button-orange"
                        htmlType="submit"
                        loading={loadingSubmit}
                      >
                        Postularme
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="content-padding background-data-fixed-section">
                <div className="data-fixed-section">
                  <div className="text-data-fixed-section">
                    <h5 className="h5-title">¿Te interesa aprender más?</h5>
                    <p>
                      Postula al Taller 24E GRATIS hasta este <strong>15 de diciembre</strong>.
                    </p>
                  </div>
                  <div className="button-data-fixed-section">
                    <Button
                      className="button-main-small button-orange"
                      onClick={() => showFormClick()}
                    >
                      Postula Ahora
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default VideoSection;
